import Vue from 'vue'
import { IContentMorphologicCodeGrid } from '@/modules/configurationModule/detail/samples/morphology/MorphologicCode.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class MorphologicCodeConfigurationServices extends Vue {
    async paginator(filterModel: any, params: any): Promise<IResponseAgGrid<IContentMorphologicCodeGrid>> {
        const response = await this.axios.put(`/configuration/morphologicCodes`, filterModel, { params })
        return response.data
    }
    async patchInBatch(request: IContentMorphologicCodeGrid[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await this.axios.patch(`/configuration/morphologicCodes/batch`, request)
        return response.data
    }
    async create(request: IContentMorphologicCodeGrid): Promise<IContentMorphologicCodeGrid> {
        const response = await this.axios.post(`/configuration/morphologicCodes`, request)
        return response.data
    }
    async deleteInBatch(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await this.axios.delete(`/configuration/morphologicCodes/batch`, { data: request })
        return response.data
    }
}

export const morphologicCodeConfigurationServices = new MorphologicCodeConfigurationServices()
